var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.inviteLandingAb !== 'd')?_c('ShareLandingNew',{attrs:{"umLink":_vm.umLink,"copyDownload":_vm.copyDownload}}):_vm._e(),(_vm.showIntro)?_c('IntroModal',{on:{"close":_vm.closeIntro}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }